import { createActionGroup, props } from '@ngrx/store';
import { BaseFapList, FapResponse } from '@api/backend';
import { ErrorResponse } from '@core/models';

export const fapsActions = createActionGroup({
  source: 'Faps',
  events: {
    'Load Feed': props<{
      t?: string,
      c?: string,
      r?: string,
      q?: string,
      a?: string,
      np?:boolean,
      ads?: boolean,
      p?: number,
      ps?: number,
      reload?: boolean
    }>(),
    'Load Feed Success': props<{ data: BaseFapList }>(),
    'Load Feed Failure': props<{ error: ErrorResponse }>(),

    'Load Item': props<{ fapId: string }>(),
    'Load Item Success': props<{ data: FapResponse }>(),
    'Load Item Failure': props<{ error: ErrorResponse }>(),
  },
});
